import React from "react";
import { TopToolbar, ListButton } from "react-admin";

export const EditActions = ({ basePath, onClose }: any) => {
  return (
    <TopToolbar>
      <ListButton
        basePath={basePath}
        label="resources.common.labels.backToList"
        onClick={() => {
          if (onClose) onClose();
        }}
      />
    </TopToolbar>
  );
};
